import { render, staticRenderFns } from "./DriverAccident.vue?vue&type=template&id=2afd18de&"
import script from "./DriverAccident.vue?vue&type=script&lang=js&"
export * from "./DriverAccident.vue?vue&type=script&lang=js&"
import style0 from "./DriverAccident.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2afd18de')) {
      api.createRecord('2afd18de', component.options)
    } else {
      api.reload('2afd18de', component.options)
    }
    module.hot.accept("./DriverAccident.vue?vue&type=template&id=2afd18de&", function () {
      api.rerender('2afd18de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DriverAccident.vue"
export default component.exports